import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import encodeListFilterValues, { readListFilterValues } from "~/helpers/listFilterValues";
import { CUSTOMERS_BASE_PATH } from "~fulfill/customers/customer/helpers/customerGroupMembersScope";

const CUSTOMER_LIST_TARGET_KIND = "customerList";

const buildCustomerListTarget = (listId: string, customerIds: readonly string[]): ContinuationTarget => ({
	listFilters: { customerIds: encodeListFilterValues(customerIds) },
	targetId: listId,
	targetKind: CUSTOMER_LIST_TARGET_KIND
});

const readCustomerListScope = (listFilters: Record<string, string> | undefined): null | string[] =>
	readListFilterValues(listFilters?.customerIds);

const findMissingCustomerIds = (
	customerIds: readonly string[],
	customers: readonly { customerId: string }[]
): string[] => customerIds.filter((id) => !customers.some((customer) => customer.customerId === id));

const scopeCustomers = <T extends { customerId: string }>(
	customers: T[],
	customerIds: null | readonly string[]
): T[] => (customerIds ? customers.filter((customer) => customerIds.includes(customer.customerId)) : customers);

const customerListReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: () => CUSTOMERS_BASE_PATH,
	matchesRoute: () => null
};

const customerListScope = {
	adapter: customerListReceiverIdentityAdapter,
	buildCustomerListTarget,
	CUSTOMER_LIST_TARGET_KIND,
	findMissingCustomerIds,
	readCustomerListScope,
	scopeCustomers
} as const;

export default customerListScope;
